import { Instagram, MessageCircle } from "lucide-react";
import { SITE, whatsappUrl } from "@/config/site";
import { patternBg } from "@/lib/patternBg";

// Cartão de apoio sobre o padrão vichy rosa: convite para falar com a Alexandra.
// Alternativa discreta ao checkout: a Alexandra também recebe encomendas por mensagem.
// WhatsApp abre uma conversa com a mensagem já escrita. O Instagram só abre o perfil: uma ligação normal não consegue abrir uma conversa nova.
const pill = "inline-flex min-h-[44px] items-center gap-2 rounded-full bg-ivory px-5 text-sm font-medium text-ink shadow-[0_2px_10px_rgba(117,67,75,.10)] ring-1 ring-bordeaux/15 transition-colors active:bg-white hover:text-bordeaux";
const BG = patternBg("vichy-rosa-claro", "246,226,226", 0.72, 150);

export const MessageOrder = ({ message, title = "Tens um pedido especial?", className = "", testId = "message-order" }) => {
  const wa = whatsappUrl(message);
  return (
    <div className={`relative isolate overflow-hidden rounded-3xl bg-[#F3DCDC] p-5 ring-1 ring-bordeaux/10 ${className}`} data-testid={testId}>
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10" style={BG} />
      <p className="font-display text-[1.0625rem] leading-snug text-ink">{title} <span aria-hidden="true">🤍</span></p>
      <p className="mt-1.5 max-w-[46ch] text-[13.5px] leading-relaxed text-ink/75" data-testid={`${testId}-hint`}>
        Envia-me mensagem para o Instagram para falarmos sobre o teu pedido ou para esclarecer qualquer dúvida.
      </p>
      <div className="mt-3.5 flex flex-wrap gap-2.5">
        {wa && (
          <a href={wa} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-whatsapp`} className={pill}>
            <MessageCircle className="h-4 w-4 text-bordeaux" aria-hidden="true" /> WhatsApp
          </a>
        )}
        <a href={SITE.instagram.url} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-instagram`} className={pill}>
          <Instagram className="h-4 w-4 text-bordeaux" aria-hidden="true" /> {SITE.instagram.handle}
        </a>
      </div>
    </div>
  );
};

export const productMessage = (name, patternName) => `Olá Alexandra! Gostava de saber mais sobre ${name}${patternName ? ` (padrão ${patternName})` : ""} 😊`;
